<template>
  <section>
    <b-modal :active.sync="isComponentModalActive" has-modal-card :can-cancel="false">
      <div class="modal-card">
        <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
        <header class="modal-card-head">
          <p v-if="!this.stablishment_id" class="modal-card-title">Crear Establecimiento</p>
          <p v-else class="modal-card-title">Editar Establecimiento</p>
        </header>
        <section class="modal-card-body">
          <b-field label="Nombre">
            <b-input
              type="text"
              :value="stablishment.name"
              v-model="stablishment.name"
              placeholder="Nombre"
              required
            ></b-input>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="closeBasic()">Cerrar</button>
          <button v-if="!this.stablishment_id" class="button is-primary" @click="createStablishment()">Guardar</button>
          <button v-else class="button is-primary" @click="editStablishment()">Editar</button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>
<script>
export default {
  props: [
    "isComponentModalActive",
    "closeBasic",
    "chargeStablishmentList",
    "stablishment_id",
  ],
  data() {
    return {
      stablishment: {
        name: "",
      },
      isLoading: false,
    };
  },
  created: function () {
    this.isLoading = true;
    if (this.stablishment_id) {
      this.chargeStablishmentData().then(() => {
        this.isLoading = false;
      });
    } else {
      this.isLoading = false;
    }
  },
  methods: {
    createStablishment: async function () {
      this.isLoading = true;
      let data = {
        ...this.stablishment,
      };
      await this.$http.post(`api/${localStorage.getItem('perfil')}/stablishment`, data).then(
        (response) => {
          //Limpia el objeto stablishment
          for (const i in this.stablishment) {
            this.stablishment[i] = "";
          }
          console.log("POST:", response.body);
          this.chargeStablishmentList();
          this.closeBasic();
          this.toast("Creado el establecimiento", "is-success");
          this.isLoading = false;
        },
        (response) => {
          this.toast("Error al crear", "is-danger");
          this.isLoading = false;
          console.log("error: ", response);
        }
      );
    },
    editStablishment: function () {
      this.isLoading = true;
      let data = {
        ...this.stablishment,
      };
      this.$http
        .put(`api/${localStorage.getItem('perfil')}/stablishment/` + this.stablishment_id, data)
        .then(
          (response) => {
            //Limpia el objeto prevition
            for (const i in this.stablishment) {
              this.stablishment[i] = "";
            }
            console.log("PUT:", response.body);
            this.chargeStablishmentList();
            this.closeBasic();
            this.toast("Editado el establecimiento", "is-success");
            this.isLoading = false;
          },
          (response) => {
            this.toast("Error al editar", "is-danger");
            this.isLoading = false;
            console.log("error: ", response);
          }
        );
    },
    chargeStablishmentData: async function () {
      await this.$http
        .get(`api/${localStorage.getItem('perfil')}/stablishment/` + this.stablishment_id)
        .then(
          (response) => {
            this.stablishment.name = response.body.stablishment.name;
          },
          (response) => {
            console.log(response);
          }
        );
    },
  },
};
</script>